<div class="sub-detail" *ngIf="!loading && detail; else loadingTpl">
  <div class="sub-detail__header">
    <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text" label="Back" (click)="back()"></button>
    <div>
      <h2>{{ detail.userName || 'Subscriber' }}</h2>
      <p>{{ detail.userEmail }} · {{ detail.subscriptionPlan || '—' }} · {{ detail.subscriptionStatus || '—' }}</p>
    </div>
  </div>

  <div class="sub-detail__grid">
    <section class="card">
      <h3>Subscription</h3>
      <p><strong>User ID:</strong> {{ detail.userId }}</p>
      <p><strong>Subscription ID:</strong> {{ detail.subscriptionId }}</p>
      <p><strong>Created:</strong> {{ detail.createdOn | date: 'medium' }}</p>
      <p *ngIf="hubUrl()"><strong>Hub:</strong> <a [href]="hubUrl()" target="_blank" rel="noopener">{{ detail.hubName || detail.hubUrlHandler }}</a></p>
      <p *ngIf="!detail.hasHub"><strong>Hub:</strong> No hub yet</p>
      <p *ngIf="stripeUrl()"><strong>Stripe:</strong> <a [href]="stripeUrl()" target="_blank" rel="noopener">Open in Stripe</a></p>
    </section>

    <section class="card" *ngIf="isAdmin">
      <h3>Assigned Ops (project)</h3>
      <p class="hint">Assign Ops before a hub exists. Syncs to hub when created/linked.</p>
      <p><strong>Project Ops:</strong> {{ detail.projectAssignedOpsEmail || '—' }}</p>
      <p><strong>Hub Ops:</strong> {{ detail.hubAssignedOpsEmail || '—' }}</p>
      <p-dropdown [options]="opsOptions" [(ngModel)]="selectedOpsEmail" placeholder="Select Ops" [showClear]="true" styleClass="w-full"></p-dropdown>
      <button pButton type="button" label="Save assignment" class="p-mt-2" (click)="assignProjectOps()" [disabled]="!detail.projectId"></button>
    </section>

    <section class="card" *ngIf="detail.projectId; else noProjectWorkflow">
      <h3>Royal workflow</h3>
      <p><strong>Current stage:</strong> {{ detail.stage || detail.projectStage || '—' }}</p>
      <p-dropdown
        [options]="stageOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="selectedStage"
        placeholder="Stage"
        styleClass="w-full"
      ></p-dropdown>
      <button pButton type="button" label="Update stage" class="p-mt-2" (click)="saveStage()" [disabled]="saving || !detail.projectId"></button>
    </section>
    <ng-template #noProjectWorkflow>
      <section class="card">
        <h3>Royal workflow</h3>
        <p class="hint">No Royal project on this subscription (Premium/Free). PM stage tools apply to Royal only.</p>
      </section>
    </ng-template>

    <section class="card">
      <h3>Hub Definition & Sales Plan</h3>
      <input pInputText class="w-full" [(ngModel)]="hubDefinitionDocUrl" placeholder="https://..." />
      <button pButton type="button" label="Save document URL" class="p-mt-2" (click)="saveDocUrl()" [disabled]="saving || !detail.projectId"></button>
    </section>

    <section class="card">
      <h3>Customer-visible notes</h3>
      <textarea pInputTextarea rows="4" class="w-full" [(ngModel)]="customerVisibleNotes"></textarea>
      <button pButton type="button" label="Save notes" class="p-mt-2" (click)="saveNotes()" [disabled]="saving || !detail.projectId"></button>
    </section>

    <section class="card">
      <h3>Hub readiness</h3>
      <p class="hint" *ngIf="!detail.hasHub">No hub linked yet — checklist stays empty until a hub is attached.</p>
      <ul class="readiness" *ngIf="(detail.readiness || []).length; else noReadiness">
        <li *ngFor="let item of detail.readiness">
          <i class="pi" [ngClass]="item.complete ? 'pi-check-circle ok' : 'pi-times-circle bad'"></i>
          {{ readinessLabel(item.id) }}
        </li>
      </ul>
      <ng-template #noReadiness>
        <p class="hint">Readiness data unavailable.</p>
      </ng-template>
    </section>

    <section class="card">
      <h3>SEO articles</h3>
      <ng-container *ngIf="detail.mediumProfileUrl || detail.redditProfileUrl; else noSeoLinks">
        <p *ngIf="detail.mediumProfileUrl">
          <strong>Medium:</strong>
          <a [href]="detail.mediumProfileUrl" target="_blank" rel="noopener">{{ detail.mediumProfileUrl }}</a>
        </p>
        <p *ngIf="detail.redditProfileUrl">
          <strong>Reddit:</strong>
          <a [href]="detail.redditProfileUrl" target="_blank" rel="noopener">{{ detail.redditProfileUrl }}</a>
        </p>
      </ng-container>
      <ng-template #noSeoLinks>
        <p class="hint">No Medium or Reddit profile links yet.</p>
      </ng-template>
    </section>

    <section class="card card--wide" *ngIf="detail.projectId">
      <h3>Task list</h3>
      <div class="task-add p-fluid">
        <label>Description</label>
        <textarea pInputTextarea rows="2" class="w-full" [(ngModel)]="newTaskDescription" placeholder="New task description"></textarea>
        <div class="task-add__row">
          <div>
            <label>Status</label>
            <p-dropdown
              [options]="taskStatusOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="newTaskStatus"
              styleClass="w-full"
            ></p-dropdown>
          </div>
          <div>
            <label>Due date</label>
            <p-calendar
              [(ngModel)]="newTaskDueDate"
              [showIcon]="true"
              appendTo="body"
              dataType="string"
              dateFormat="yy-mm-dd"
              [showButtonBar]="true"
              placeholder="Optional"
              styleClass="w-full"
            ></p-calendar>
          </div>
          <div class="task-add__actions">
            <button
              pButton
              type="button"
              label="Add task"
              icon="pi pi-plus"
              (click)="addTask()"
              [disabled]="addingTask || !newTaskDescription.trim()"
            ></button>
          </div>
        </div>
      </div>

      <p class="hint" *ngIf="tasksLoading">Loading tasks…</p>
      <p class="hint" *ngIf="!tasksLoading && !tasks.length">No tasks yet.</p>

      <p-table *ngIf="tasks.length" [value]="tasks" styleClass="p-datatable-sm task-table" [loading]="tasksLoading">
        <ng-template pTemplate="header">
          <tr>
            <th>Description</th>
            <th style="width: 9rem">Status</th>
            <th style="width: 11rem">Due date</th>
            <th style="width: 9rem">Created</th>
            <th style="width: 6rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-task>
          <tr>
            <td>
              <textarea pInputTextarea rows="2" class="w-full" [(ngModel)]="task.editDescription"></textarea>
            </td>
            <td>
              <p-dropdown
                [options]="taskStatusOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="task.editStatus"
                styleClass="w-full"
              ></p-dropdown>
            </td>
            <td>
              <p-calendar
                [(ngModel)]="task.editDueDate"
                [showIcon]="true"
                appendTo="body"
                dataType="string"
                dateFormat="yy-mm-dd"
                [showButtonBar]="true"
                styleClass="w-full"
              ></p-calendar>
            </td>
            <td>{{ task.createdOn | date: 'mediumDate' }}</td>
            <td>
              <button
                pButton
                type="button"
                label="Save"
                class="p-button-sm"
                (click)="saveTask(task)"
                [disabled]="task.saving || !task.editDescription.trim()"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>

    <section class="card">
      <h3>Hub actions</h3>
      <button *ngIf="!detail.hasHub" pButton type="button" label="Create hub" icon="pi pi-plus" (click)="openCreateHub()"></button>
      <button *ngIf="detail.hasHub" pButton type="button" label="Launch Hub Editor" icon="pi pi-external-link" (click)="launchEditor()"></button>
    </section>
  </div>
</div>

<ng-template #loadingTpl>
  <p class="p-m-3">Loading subscription…</p>
</ng-template>

<p-dialog header="Create hub for subscriber" [(visible)]="isCreateHubDialogOpen" [modal]="true" [style]="{width: '480px'}">
  <div class="p-fluid">
    <label>Name</label>
    <input pInputText [(ngModel)]="createHubName" />
    <label class="p-mt-2">URL handler</label>
    <input pInputText [(ngModel)]="createUrlHandler" />
    <label class="p-mt-2" *ngIf="isAdmin">Assign Ops</label>
    <p-dropdown *ngIf="isAdmin" [options]="opsOptions" [(ngModel)]="createOpsEmail" [showClear]="true" placeholder="Ops email"></p-dropdown>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" class="p-button-text" (click)="isCreateHubDialogOpen=false"></button>
    <button pButton type="button" label="Create" (click)="submitCreateHub()" [disabled]="isCreatingHub"></button>
  </ng-template>
</p-dialog>